import Filters from './filters';
import Lineups from './lineups';
import Players from './players';
import Routing from './routing';
import SportConfig from './sport-config';
import Modal from './modal';
import Stacks from './stacks';
import LineupGenerator from './lineup-generator';
import Reset from './reset';
import Messages from './messages';
import TeamsCombinations from './teams-combinations';
import TeamsStacks from './teams-stacks';
import CorrelationStacking from './correlation-stacking';
import CorrelationStackingCombinations from './correlation-stacking-combinations';
import CorrelationStackingPlayers from './correlation-stacking-players';
import TeamNameStacking from './team-name-stacking';
import PlayerNameStacking from './player-name-stacking';
import PlayerPositionStacking from './player-position-stacking';
import CptPositionStacking from './cpt-position-stacking';
import Lineup from './lineup';
import OptimizationConfig from './optimization-config';
import Optimization from './optimization';
import UsedPlayers from './used-players';
import PlayersLock from './players-lock';
import PlayersExclusion from './players-exclusion';
import PlayersSympathy from './players-sympathy';
import PointsBoundary from './points-boundary';
import SalaryBoundary from './salary-boundary';
import SalaryCap from './salary-cap';
import PlayerSettingPopup from './player-setting-popup';
import ModesConfig from './modes-config';
import ExposureMode from './exposure-mode';
import ProjectionPointsType from './projection-points-type';
import UserPointsType from './user-points-type';
import UniquePlayersQuantity from './unique-players-quantity';
import LineupsQuantity from './lineups-quantity';
import NonControlledHitterStacking from './non-controlled-hitter-stacking';
import RandomTeamStacking from './random-team-stacking';
import UsedTeams from './used-teams';
import CompetitionStacking from './competition-stacking';
import OpposingPitchers from './opposing-pitchers';
import DominatorStacking from './dominator-stacking';
import PlayerCombinationStacking from './player-combination-stacking';
import ProjectedOwnershipCap from './projected-ownership-cap';
import KeyPlayerStackingCombinations from './key-player-stacking-combinations';
import ProjectedOwnershipForce from './projected-ownership-force';
import FilterByTiers from './filter-by-tiers';
import Socket from './socket';
import FilterLineups from './filter-lineups';
import LateSwap from './late-swap';
import LineupResolvingProcess from './lineup-resolving-process';
import PlayersSwapped from './players-swapped';
import SinglegameForcedStacking from './singlegame-forced-stacking';
import NhlTeamStacking from './nhl-team-stacking';
import NhlLegacyTeamStacking from './nhl-legacy-team-stacking';
import F1PerTeamDriverLimits from './f1-per-team-driver-limits';
import ConstProjectionBoostRule from './projection-boost-rule';
import PlayersDropzone from './players-dropzone';
import NflSecondaryStackCombinations from './nfl-secondary-stack-combinations';
import Theme from './theme';

let Const = Object.assign(
    Filters,
    Lineups,
    Players,
    Routing,
    SportConfig,
    Modal,
    Stacks,
    LineupGenerator,
    Reset,
    Messages,
    TeamsCombinations,
    TeamsStacks,
    CorrelationStacking,
    CorrelationStackingCombinations,
    CorrelationStackingPlayers,
    TeamNameStacking,
    PlayerNameStacking,
    PlayerPositionStacking,
    CptPositionStacking,
    Lineup,
    OptimizationConfig,
    Optimization,
    UsedPlayers,
    PlayersLock,
    PlayersExclusion,
    PlayersSympathy,
    PointsBoundary,
    SalaryBoundary,
    SalaryCap,
    PlayerSettingPopup,
    ModesConfig,
    ExposureMode,
    ProjectionPointsType,
    UserPointsType,
    UniquePlayersQuantity,
    LineupsQuantity,
    NonControlledHitterStacking,
    RandomTeamStacking,
    UsedTeams,
    CompetitionStacking,
    OpposingPitchers,
    DominatorStacking,
    PlayerCombinationStacking,
    ProjectedOwnershipCap,
    KeyPlayerStackingCombinations,
    ProjectedOwnershipForce,
    FilterByTiers,
    Socket,
    FilterLineups,
    LateSwap,
    LineupResolvingProcess,
    PlayersSwapped,
    SinglegameForcedStacking,
    NhlTeamStacking,
    NhlLegacyTeamStacking,
    F1PerTeamDriverLimits,
    ConstProjectionBoostRule,
    PlayersDropzone,
    NflSecondaryStackCombinations,
    Theme,
);

export default Const;
